import React from 'react';
import { Box, Typography, Checkbox, Stack, colors } from '@mui/material';
import parse from 'html-react-parser';
import PolicyContentHelper from 'views/App/Portal/Policy/_helpers/policyContentHelper';

interface DTBPrefaceProps {
  preface: any;
  isAssetSelected: (id: string) => boolean;
  onToggleAsset: (id: string, label: string) => void;
  activeSectionId: string | null;
}

const DTBPreface: React.FC<DTBPrefaceProps> = ({ preface, isAssetSelected, onToggleAsset, activeSectionId }) => {
  const isChecked = isAssetSelected(preface.id);
  const backgroundColor = preface.id === activeSectionId ? colors.amber[50] : 'transparent';

  const handleAssetClick = () => {
    const element = document.getElementById(`preface_${preface.id}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Stack
      spacing={2}
      id={`preface_${preface.id}`}
      sx={{ cursor: 'pointer', backgroundColor }}
      onClick={handleAssetClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          checked={isChecked}
          onClick={(e) => {
            e.stopPropagation();
            onToggleAsset(preface.id, preface.title);
          }}
          sx={{ mr: 1 }}
        />
        <Typography variant='h5'>{preface.title}</Typography>
      </Box>
      {preface.content && (
        <Typography
          variant='body1'
          sx={{ pl: 4 }}
        >
          {parse(preface.content || '', {
            replace(node: any, ind: number) {
              return PolicyContentHelper.handleContent(node, ind);
            },
          })}
        </Typography>
      )}
    </Stack>
  );
};

export default DTBPreface;
